import { FaArrowCircleRight } from "react-icons/fa";
import { uploadFileOnS3 } from '~/helpers/upload';
import { useNavigate } from 'react-router-dom';
import { useGetConversationsQuery } from '~/data-provider';
import { conversationList, usePopup } from '~/helpers/store';
import { Toastr } from "~/helpers/toastr";

export default function Section6() {
    const navigate = useNavigate();
    const cState = conversationList((state) => state);
    const pState = usePopup((state) => state);
    const upload = (e) => {
        pState.setShowProcessLoading(true);
        const files = e.target.files;
        uploadFileOnS3(files, (conversationId) => {
            cState.setConvoLoad(true);
            // data provider
            useGetConversationsQuery(cState.pageNumber).then((data) => {
                cState.setConversation(data['conversations']);
                cState.setConvoLoad(false);
            });
            navigate(`/chat/${conversationId}`);
            pState.setShowProcessLoading(false);
        }, (data) => {
            let error_msg = "Something went wrong.<br>Please try again.";
            if(data?.showPopup) {
                pState.setShowPricingPopup(true);
                return;
            }
            if(data?.msg) error_msg = data?.msg;
            Toastr.error(error_msg);
            pState.setShowProcessLoading(false);
        });
    };
    
    return (
        <div id="section-6" style={{
            marginTop: "100px"
        }}>
            <div className="title">Are you Ready to Work Smarter?</div>
            <div className="description">
                Discover how millions of users are boosting productivity with AI-Pro's ChatPDF, powered by OpenAI.
            </div>
            <div className="start-now"
            onClick={()=>{
                const element = document.querySelector("#section-6 input[type='file']") as HTMLElement;
                element.click()
            }}>
                Upload PDF <FaArrowCircleRight></FaArrowCircleRight>
            </div>
            <div className='hidden'>
                <input 
                    type="file"
                    onChange={upload}
                    accept="application/pdf"
                ></input>
            </div>
        </div>
    );
}